import { httpClient } from './core';

export interface MfaDevice {
  id: number;
  device_id: string | null;
  device_name: string | null;
  user_agent: string | null;
  ip_address: string | null;
  created_at: string;
  last_used_at: string | null;
  expires_at: string;
  mfa_verified_at?: string | null;
}

export interface MfaSecuritySettingsDto {
  /** 2FA-Pflicht für alle Konten mit sensiblen Rechten (Rechteverwaltung, Sicherheit, Finanzen …). */
  enforceSensitive: boolean;
  updatedAt?: string | null;
}

export const mfaApi = {
  getMyDevices: async (): Promise<MfaDevice[]> => {
    const res = await httpClient<MfaDevice[]>('/api/auth/devices');
    if (res.error || !res.data) throw new Error(res.error || 'Fehler beim Laden der Geräte');
    return res.data;
  },
  revokeMyDevice: async (deviceRef: string): Promise<void> => {
    const res = await httpClient(`/api/auth/devices/${encodeURIComponent(deviceRef)}`, { method: 'DELETE' } as RequestInit);
    if (res.error) throw new Error(res.error || 'Gerät konnte nicht entfernt werden');
  },
};

export const mfaSecurityApi = {
  get: async (): Promise<MfaSecuritySettingsDto> => {
    const res = await httpClient<MfaSecuritySettingsDto>('/api/settings/security/mfa');
    if (res.error || !res.data) throw new Error(res.error || 'Fehler beim Laden der MFA-Sicherheitsrichtlinie');
    return res.data;
  },
  update: async (payload: Partial<MfaSecuritySettingsDto>): Promise<MfaSecuritySettingsDto> => {
    const res = await httpClient<MfaSecuritySettingsDto>('/api/settings/security/mfa', {
      method: 'PUT',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'Fehler beim Speichern der MFA-Sicherheitsrichtlinie');
    return res.data;
  },
};

export const userMfaAdminApi = {
  updatePolicy: async (
    userId: number,
    payload: { mfa_enabled?: boolean; mfa_exception?: boolean; reset_mfa?: boolean }
  ): Promise<Record<string, unknown>> => {
    const res = await httpClient<Record<string, unknown>>(`/api/users/${userId}/mfa-policy`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'MFA-Policy konnte nicht gespeichert werden');
    return res.data;
  },
  listDevices: async (userId: number): Promise<MfaDevice[]> => {
    const res = await httpClient<MfaDevice[]>(`/api/users/${userId}/devices`);
    if (res.error || !res.data) throw new Error(res.error || 'Geräte konnten nicht geladen werden');
    return res.data;
  },
  revokeDevice: async (userId: number, deviceRef: string): Promise<void> => {
    const res = await httpClient(`/api/users/${userId}/devices/${encodeURIComponent(deviceRef)}`, { method: 'DELETE' } as RequestInit);
    if (res.error) throw new Error(res.error || 'Gerät konnte nicht entfernt werden');
  },
  revokeAllDevices: async (userId: number): Promise<void> => {
    const res = await httpClient(`/api/users/${userId}/devices`, { method: 'DELETE' } as RequestInit);
    if (res.error) throw new Error(res.error || 'Geräte konnten nicht entfernt werden');
  },
};
